// ROOM_LEADER has additional permissions over NURSERY_PRACTITIONER for
// attendance approval/edit/delete — use isRoomLeader / isRoomLeaderOrAdmin
// to gate those. Other staff actions still apply uniformly via isStaffRole.
export const STAFF_ROLES = ["ROOM_LEADER", "NURSERY_PRACTITIONER"] as const;

export type StaffRole = (typeof STAFF_ROLES)[number];

export function isStaffRole(role: string | null | undefined): boolean {
  if (!role) return false;
  return (STAFF_ROLES as readonly string[]).includes(role);
}

export function isRoomLeader(role: string | null | undefined): boolean {
  return role === "ROOM_LEADER";
}

export function isNurseryAdmin(role: string | null | undefined): boolean {
  return role === "NURSERY_ADMIN";
}

export function isRoomLeaderOrAdmin(role: string | null | undefined): boolean {
  return isRoomLeader(role) || isNurseryAdmin(role);
}
